<template>
    <section class="bg-nomad-pinnacle px-6 pb-20 pt-16 text-nomad-primary sm:pb-28 sm:pt-20">
        <div class="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:gap-20">
            <div>
                <p class="w-fit rounded-full border border-nomad-primary/20 bg-white/45 px-3 py-1 text-xs font-extrabold uppercase tracking-[0.16em] text-nomad-primary/75">Plans for the next stage</p>
                <h1 class="mt-6 max-w-3xl text-5xl font-extrabold leading-[0.98] tracking-tight sm:text-6xl lg:text-7xl">A clear path from idea to growth.</h1>
                <p class="mt-6 max-w-2xl text-lg leading-relaxed text-nomad-primary/75 sm:text-xl">Choose a focused starting point or a complete growth partner. Every plan is shaped around your goals, your audience, and the next move your business needs.</p>
            </div>
            <div class="flex justify-center lg:justify-end">
                <img src="/assets/images/discover-mock.svg" class="w-full max-w-[34rem] rounded-[1.5rem] p-2 shadow-[0_1rem_2.5rem_rgba(42,38,64,0.12)]" alt="Nexa website and digital product preview">
            </div>
        </div>
    </section>
    <Container>
        <C2a title="In-Hurry" subtitle="Our In-Hurry plan is the fastest way to get your website live. We'll build you a beautiful, minimalist site that's optimized for speed and user experience. This plan is perfect if you need a simple, yet effective online presence quickly." cta="Pay $839" url="/checkout" />
    </Container>
    <Container class="flex flex-col gap-8">
        <PlansFull />
    </Container>
    
</template>
<script>
import C2a from '@/components/C2a.vue';
import Container from '@/layouts/Container.vue';
import PlansFull from '@/components/PlansFull.vue';
export default {
    components: {
    C2a,
    Container,
    PlansFull
},
    data() {
        return {
            contents: [
                {
                    id: 1,
                    title: 'Research & planing',
                    description: 'Our cross-functional design, development and business analysis team is ready to take on your next project, being guided by in-depth tech expertise, data-driven insights and your business goals.',
                    icon: '/assets/icons/star.svg'
                },
                {
                    id: 2,
                    title: 'Design & Development',
                    description: 'Our cross-functional design, development and business analysis team is ready to take on your next project, being guided by in-depth tech expertise, data-driven insights and your business goals.',
                    icon: '/assets/icons/code.svg'
                },
                {
                    id: 3,
                    title: 'SEO & Marketing',
                    description: 'Our cross-functional design, development and business analysis team is ready to take on your next project, being guided by in-depth tech expertise, data-driven insights and your business goals.',
                    icon: '/assets/icons/zap-off.svg'
                }
            ],
            projects: [
                {
                    id: 1,
                    name: 'Flex Cleaning Service',
                    description: 'Our cross-functional design, development and business analysis team is ready to take on your next project, being guided by in-depth tech expertise, data-driven insights and your business goals. being guided by in-depth tech expertise, data-driven insights and your business goals.',
                    color: '#D6D3E2',
                    url: '',
                    image: '/assets/images/screen-fc.png',
                    stats: [{number: '5x', context: 'branches'}, {number: '700K', context: 'transactions'}]
                },
                {
                    id: 2,
                    name: 'Horn Daily',
                    description: 'Our cross-functional design, development and business analysis team is ready to take on your next project, being guided by in-depth tech expertise, data-driven insights and your business goals. being guided by in-depth tech expertise, data-driven insights and your business goals.',
                    color: '#D5CB97',
                    url: '',
                    image: '/assets/images/screen-hd.png',
                    stats: [{number: '200k', context: 'articles'}, {number: '150K', context: 'visits'}]
                },
                {
                    id: 3,
                    name: 'Nomad Lyrics',
                    description: 'Our cross-functional design, development and business analysis team is ready to take on your next project, being guided by in-depth tech expertise, data-driven insights and your business goals. being guided by in-depth tech expertise, data-driven insights and your business goals.',
                    color: '#97D5B4',
                    url: '',
                    image: '/assets/images/screen-discover.png',
                    stats: [{number: '1.2M', context: 'streams'}, {number: '100K', context: 'visits'}]
                }
            ]
        }
    }
}
</script>